angular.module("app").controller("ClockController", [
    '$scope',
    'settingsService',
    '$interval',
    function ($scope, settingsService, $interval) {
        var settings = settingsService.getSettings();
        $scope.clock = new Date(settings.time);
        var timeDiff = new Date();
        $interval(function () {
            var currentTime = new Date(), milliSeconds;
            milliSeconds = currentTime - timeDiff;
            $scope.clock = new Date(new Date(settings.time).getTime() + milliSeconds);
        }, 1000)
    }
]);